"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface CCETailoringQuestionsProps {
  onBack?: () => void;
}

const tailoringQuestions: TailoringQuestion[] = [
  // No questions configured yet
];

export default function CCETailoringQuestions({ onBack }: CCETailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Cash & Cash Equivalents"
      title="Cash & Cash Equivalents - Tailoring Questions"
      description="No questions configured yet."
      questions={tailoringQuestions}
      onBack={onBack}
    />
  );
}



